












































































































import { mapActions, mapState } from 'vuex';
import AuthLayout from '@/views/AuthViews/AuthLayout.vue';
import { getDefaultRouteByRole } from '@/router';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import jwt_decode from 'jwt-decode';
import { AuthTokenData } from '@/api/schema';
import { required } from '@/helpers/validation';
import { trimEnd } from 'lodash';
import { wait } from '@/helpers/wait';
import MfaQR from '@/components/secure/MfaQR.vue';

const isProdEnv = process.env.VUE_APP_CI_CD_ENV === 'prod';

export default {
  name: 'LoginView',
  components: {
    AuthLayout,
    MfaQR
  },
  data(): any {
    return {
      mfaFormValid: true,
      formValid: true,
      email: '',
      password: '',
      mfaCode: '',
      showPassword: false,
      submitProcessing: false,
      isVerifyingMfaProcessing: false
    };
  },
  mounted(): void {
    this.checkAuthToken();
    this.$nextTick(() => document.body.click());
  },
  computed: {
    ...mapState('app', ['isSuperAdmin']),
    ...mapState('Auth', ['isMfaRequired', 'isMfaSetup', 'mfaToken']),

    isMfaValid(): boolean {
      return this.mfaCode?.length === 6;
    },

    rules(): Record<string, unknown> {
      return {
        email: [(v) => required(v, 'E-Mail')],
        password: [
          (v) => !v?.includes(' ') || 'No blank space available',
          (v) => required(v, 'Password')
        ],
        mfaCode: [(v) => required(v, 'Password'), (v) => v.length === 6]
      };
    },

    isCredentialAuthFormHidden(): boolean {
      return isProdEnv && this.isSuperAdmin;
    }
  },
  methods: {
    ...mapActions('Auth', ['login', 'verifyMfa', 'setupMfa', 'authorize']),

    submitMfaHandler(): void {
      const mfaForm = this.$refs.mfaForm;
      mfaForm.validate();
      this.$nextTick((): void => {
        if (this.mfaFormValid) {
          this.verifyMfaCode();
        }
      });
    },
    submitHandler(): void {
      const form = this.$refs.form;
      form.validate();
      this.$nextTick((): void => {
        if (this.formValid) {
          this.loginUser();
        }
      });
    },
    checkAuthToken(): void {
      const search = new URLSearchParams(window.location.search);
      const token = search.get('token');

      if (!token) return;

      const { exp }: AuthTokenData = jwt_decode(token);

      if (Date.now() < exp * 10 ** 3) {
        this.authorize(token);
        this.proceedAuthorization();
      }
    },
    proceedAuthorization(): void {
      this.$router
        .push(getDefaultRouteByRole(this.$role.name))
        .catch(errorToastMessage);
    },
    async loginUser(): Promise<void> {
      if (this.submitProcessing) {
        return;
      }

      this.submitProcessing = true;
      const { email, password } = this;

      try {
        await this.login({ email, password });
        if (this.isMfaRequired) {
          return;
        }

        this.proceedAuthorization();
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.submitProcessing = false;
      }
    },
    async verifyMfaCode(): Promise<void> {
      if (this.isVerifyingMfaProcessing) {
        return;
      }

      this.isVerifyingMfaProcessing = true;
      const { mfaToken, mfaCode } = this;

      try {
        const handler = this.isMfaSetup ? this.verifyMfa : this.setupMfa;

        await handler({
          token: mfaToken,
          code: mfaCode
        });

        this.proceedAuthorization();
      } catch (error) {
        errorToastMessage(error);
      } finally {
        await wait(300);
        this.isVerifyingMfaProcessing = false;
      }
    },
    async signInWith(provider: string): Promise<void> {
      if (this.submitProcessing) {
        return;
      }

      this.submitProcessing = true;

      const apiOrigin = trimEnd(process.env.VUE_APP_API_URL, '/');
      const url = `${apiOrigin}/oauth2/authorization/${provider}`;

      window.location.href = url;
    },
    async handleClickSignInWithGoogleButton(): Promise<void> {
      await this.signInWith('google');
    }
  }
};
